import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'

import GetTextPlugin from 'vue-gettext'
import translations from './assets/langs/translations.json'

import VueClipboard from 'vue-clipboard2'

import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

Vue.config.productionTip = false
Vue.use(GetTextPlugin, {
	availableLanguages: {
		en: 'English',
		pt: 'Português'
	},
	defaultLanguage: 'en',
	translations: translations
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueFileAgent)
Vue.use(VueFileAgentStyles)

//axios.defaults.baseURL = 'http://localhost:5500'
axios.defaults.baseURL = 'https://api.naltio.com'
axios.defaults.withCredentials = true

function enableInterceptors() {
	axios.interceptors.response.use(response => {
		store.dispatch("SET_LOADING", false)
		return response
	}, error => {
		const status = error.response ? error.response.status : null

		store.dispatch("SET_LOADING", false)

		if (status === 404) {
			router.push({
				name: "not-found"
			});
		}

		return Promise.reject(error);
	});

	axios.interceptors.request.use((config) => {
		store.dispatch("SET_LOADING", true)
		return config
	}, (error) => {
		store.dispatch("SET_LOADING", false)
		return Promise.reject(error)
	});
}

enableInterceptors()

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
